import * as React from 'react';
import { hydrate, render } from 'react-dom';
import { once } from 'lodash';
import LooselyLazy from 'react-loosely-lazy';
import { ModelsCache } from 'rest/models/models-cache/models-cache';
import { install as installWebComponents } from 'view/web-components';
import { initBrowserMetricsV3 } from '@atlassian/help-center-common-util/analytics/browser-metrics-v3';
import { initialiseConnectAndSentryAndCleanUrl } from '@atlassian/help-center-common-util/bootstrap';
import { AtlassianHelp } from './atlassian-help';
import { getEnv, getIsPageServerSideRendered } from './util/env';
import { initialisePlatformFeatureFlags } from './util/feature-manager/feature-manager';
import { getMetaData } from './util/meta';

const initialiseAppUtilities = once(() => {
    initialisePlatformFeatureFlags();
    initialiseConnectAndSentryAndCleanUrl();
    installWebComponents();
    initBrowserMetricsV3();
});

export const getApplication = () => {
    const atlassianHelpConfig = { ...getEnv(), ...getMetaData() };

    ModelsCache.getInstance().initFromInitialJsonPayload();
    initialiseAppUtilities();

    return <AtlassianHelp config={atlassianHelpConfig} />;
};

export const bootstrap = () => {
    LooselyLazy.init({
        retry: 3,
    });
    const rootId = 'root';
    // Invalid report.
    // eslint-disable-next-line testing-library/render-result-naming-convention
    const isPageServerSideRendered = getIsPageServerSideRendered();
    let root = document.getElementById(rootId);
    if (!root) {
        // If there is no root element available yet, add one.
        root = document.createElement('span');
        root.id = rootId;
        document.body.appendChild(root);
    }

    if (isPageServerSideRendered) {
        hydrate(getApplication(), root);
    } else {
        render(getApplication(), root);
    }
};
